import { createFileRoute } from '@tanstack/react-router'
import DashboardScreen from './-components/screen'
import { Loading } from '@/layouts/loading'
import { pharmacyClient } from '@/connect'
import dayjs from 'dayjs'

export const Route = createFileRoute('/(inventory)/branch/_layout/reports/')({
  component: DashboardScreen,
  loader: async () => {
    const stockPoinstInfo =  await pharmacyClient.getStockPoints({
      startDate: dayjs().startOf('month').unix(),
      endDate: dayjs().endOf('month').unix(),
    })
    const overviewData = await pharmacyClient.overviewReport({
        startDate: dayjs().startOf('day').unix(),
        endDate: dayjs().endOf('day').unix(),
    })

    const revenueData = await pharmacyClient.revenueReport({
        startDate: dayjs().startOf('year').unix(),
        endDate: dayjs().endOf('year').unix(),
    });
    return {
      stockPoinstInfo: stockPoinstInfo,
      overview: overviewData,
      revenue: revenueData,
    }
  },
  pendingComponent: () => <Loading />,
  pendingMinMs: 1000,
  pendingMs: 1,
})
